import { render, staticRenderFns } from "./LandingPageV2.vue?vue&type=template&id=05cc10e2&scoped=true"
import script from "./LandingPageV2.vue?vue&type=script&lang=js"
export * from "./LandingPageV2.vue?vue&type=script&lang=js"
import style0 from "./LandingPageV2.vue?vue&type=style&index=0&id=05cc10e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc10e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
